import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

export function cleanQuickStartText(value: unknown): string {
  const text = `${value ?? ''}`.trim();
  if (!text.includes('<')) return text;

  const document = new DOMParser().parseFromString(text, 'text/html');
  return (document.body.textContent || '').replace(/\s+/g, ' ').trim();
}

export const quickStartTextRequiredValidator: ValidatorFn =
  (control: AbstractControl): ValidationErrors | null =>
    cleanQuickStartText(control.value) ? null : {required: true};
